// a fetch started before the mutation committed would otherwise be reused and cache the old state
export var AFTER_MUTATION = { cancelRefetch: true };
